import { AfterViewInit, Component, forwardRef, Input, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';
import { FilterFieldsBaseComponent } from 'app/shared/components/list-filter/filter-fields-base.component';
import { addDays, toFormattedDateString } from 'app/shared/helpers/date-helpers';
import { ReactiveFormHelperService } from 'app/shared/helpers/reactive-form-helper.service';
import { Filter, FilterOperatorType } from 'app/shared/models/filter.model';
import { DateRange } from 'app/shared/models/date-range.model';
import { CaseActivityListFilterModel } from '../models/case-activity-list-filter.model';
import { CaseActivityListMode } from '../models/CaseActivityListMode';
import { ActivityListService } from '../services/activity-list.service';

@Component({ standalone: false,
  selector: 'activity-list-filter',
  templateUrl: './activity-list-filter.component.html',
  providers: [{ provide: FilterFieldsBaseComponent, useExisting: forwardRef(() => ActivityListFilterComponent) }],
})
export class ActivityListFilterComponent extends FilterFieldsBaseComponent implements OnInit, AfterViewInit {

  @Input() caseActivityListMode: CaseActivityListMode = CaseActivityListMode.History;
  @Input() activityLevel: number;

  model: CaseActivityListFilterModel = new CaseActivityListFilterModel();

  activityTypeLookupData: any[];

  dataForm: FormGroup;
  get summary(): AbstractControl {
    return this.dataForm.controls['summary'];
  }
  get activityDate(): AbstractControl {
    return this.dataForm.controls['activityDate'];
  }
  get activityType(): AbstractControl {
    return this.dataForm.controls['activityType'];
  }

  constructor(private fb: FormBuilder, private service: ActivityListService, private formHelperService: ReactiveFormHelperService) {
    super();
  }

  ngOnInit() {
    this.dataForm = this.fb.group({
      summary: [this.model.summary],
      activityDate: [this.model.activityDate],
      activityType: [this.model.activityType],
    });


    if (this.caseActivityListMode === CaseActivityListMode.History) {
      this.service.getFilterLookupData().then((response) => {
        this.activityTypeLookupData = this.formHelperService.createLookupData(response.activityTypeLookupData);
        this.activityTypeLookupData.unshift({ id: 0, text: 'All Types' });
      });
    } else {
      // this.service.getTribunalFilterLookupData().then((response) => {
      //   this.activityTypeLookupData = this.formHelperService.createLookupData(response.activityTypeLookupData);
      //   this.activityTypeLookupData.unshift({ id: 0, text: 'All Documents & Emails' });
      // });
    }

    this.dataForm.markAsPristine();
  }

  ngAfterViewInit() {
    this.notifyFilterChanged();
  }

  resetToDefault() {
    this.dataForm.controls['summary'].setValue(this.model.summary);
    this.dataForm.controls['activityDate'].setValue(null);
    this.dataForm.controls['activityType'].setValue(this.model.activityType);
  }

  getFilters(): Array<Filter> {
    const filters = new Array<Filter>();

    if (this.summary.value) {
      filters.push(new Filter('Summary', new FilterOperatorType().Contains, this.summary.value));
    }

    const activityDate: DateRange = this.activityDate.value;
    if (activityDate?.start) {
      filters.push(new Filter('ActivityDate', new FilterOperatorType().GreaterThanEqual, toFormattedDateString(activityDate.start, 'DD-MMM-YYYY')));
    }
    if (activityDate?.end) {
      filters.push(new Filter('ActivityDate', new FilterOperatorType().LessThan, toFormattedDateString(addDays(activityDate.end, 1), 'DD-MMM-YYYY')));
    }

    if (this.activityType.value && this.activityType.value > 0) {
      filters.push(new Filter('ActivityTypeId', new FilterOperatorType().Equals, this.activityType.value));
    }

    return filters;
  }
}
